import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';

@Injectable()
export class ErrorService {

    markAllControlsAsTouched(form: NgForm): void {
        Object.keys(form.controls).map(key => form.controls[key])
            .forEach(control => control.markAsTouched());
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/error.service.ts